/* Curated categories coexist with native price/availability/sort controls. */
(() => {
  'use strict';
  const registry = new Map();
  function setup(nav) {
    if (registry.has(nav)) return;
    const buttons = [...nav.querySelectorAll('[data-xe-filter]')], status = nav.querySelector('[data-xe-filter-count]');
    const grid = document.querySelector('#ProductGridContainer');
    const controls = document.createElement('div'); controls.className = 'xe-catalog-select';
    const label = document.createElement('label'); label.textContent = 'EQUIPMENT CATEGORY';
    const select = document.createElement('select'); select.id = `XECategory-${nav.closest('.shopify-section')?.id || 'catalog'}`; label.htmlFor = select.id;
    buttons.forEach(button => { const option = document.createElement('option'); option.value = button.dataset.xeFilter; option.textContent = button.textContent.trim().replace(/\s+/g, ' '); select.append(option); });
    controls.append(label, select); nav.prepend(controls); nav.dataset.xeReady = 'true';
    let active = 'all';
    const requested = () => new URLSearchParams(location.search).get('xe_category') || 'all';
    function syncForms() {
      document.querySelectorAll('facet-filters-form form').forEach(form => {
        let input = form.querySelector('input[name="xe_category"]');
        if (active === 'all') { input?.remove(); return; }
        if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'xe_category'; form.append(input); }
        input.value = active;
      });
    }
    function apply(filter) {
      active = buttons.some(button => button.dataset.xeFilter === filter) ? filter : 'all';
      const cards = [...document.querySelectorAll('#product-grid > [data-xe-category]')];
      const nativeSort = new URLSearchParams(location.search).get('sort_by');
      if (!nativeSort || nativeSort === 'manual') {
        const rank = card => Number.parseInt((card.dataset.xeOrders || '').split(`|${active}:`)[1]?.split('|')[0] || '9999', 10);
        const ordered = [...cards].sort((a,b) => rank(a) - rank(b) || Number(a.dataset.xeDefaultOrder) - Number(b.dataset.xeDefaultOrder));
        if (ordered.some((card,index) => card !== cards[index])) ordered.forEach(card => card.parentElement.append(card));
      }
      let count = 0;
      cards.forEach(card => { card.hidden = active !== 'all' && !(card.dataset.xeCategory || '').includes(`|${active}|`); if (!card.hidden) count++; });
      buttons.forEach(button => { const current = button.dataset.xeFilter === active; button.classList.toggle('is-active',current); button.setAttribute('aria-pressed',String(current)); });
      select.value = active;
      const text = `${count} ${count === 1 ? 'product' : 'products'}`;
      // The filter drawer header carries the same count as the toolbar (it used to show Shopify's total, hidden products included)
      [status, ...document.querySelectorAll('#ProductCount,#ProductCountDesktop,.mobile-facets__count')].filter(Boolean).forEach(element => { if (element.textContent !== text) element.textContent = text; });
      syncForms();
    }
    function commit(filter) {
      const url = new URL(location.href);
      if (filter === 'all') url.searchParams.delete('xe_category'); else url.searchParams.set('xe_category',filter);
      if (url.href !== location.href) history.pushState({ ...history.state, searchParams: url.searchParams.toString() },'',url.pathname + url.search + url.hash);
      apply(filter);
    }
    const click = event => { const button = event.target.closest('[data-xe-filter]'); if (button && nav.contains(button)) commit(button.dataset.xeFilter); };
    const change = () => commit(select.value), back = () => apply(requested());
    nav.addEventListener('click',click); select.addEventListener('change',change); window.addEventListener('popstate',back);
    const observer = grid ? new MutationObserver(() => apply(active)) : null;
    observer?.observe(grid,{ childList:true,subtree:true });
    apply(requested());
    registry.set(nav,() => { observer?.disconnect(); nav.removeEventListener('click',click); select.removeEventListener('change',change); window.removeEventListener('popstate',back); controls.remove(); });
  }
  const init = (scope=document) => scope.querySelectorAll('[data-xe-quick-filters]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => init(),{once:true}); else init();
  document.addEventListener('shopify:section:load',event => init(event.target));
  document.addEventListener('shopify:section:unload',event => { for (const [nav,destroy] of registry) if (event.target.contains(nav)) { destroy(); registry.delete(nav); } });
})();
